import { createSlice, createAsyncThunk, createSelector } from "@reduxjs/toolkit";
import axios from "axios";
const APIURL = process.env.REACT_APP_API_URL_LOCAL;

export const login = createAsyncThunk(
  "user/login",
  async (params) => {
    const response = await axios.post(
      `${APIURL}/auth/login`,
      params
    );
    return response;
  }
);


export const changePassword = createAsyncThunk(
  "user/changePassword",
  async (params, thunkAPI) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };

      const res = await axios.post(
        `${APIURL}/auth/changePassword`,
        params,
        config
      );

      return res.data; // ✅ This contains { message: "..." } from backend
    } catch (error) {
      // Optional: handle error properly
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : {},
    token: localStorage.getItem('token') ? localStorage.getItem('token') : "",
    userLoggedIn: false,
    Activeusers: 0,
    todayNewusers: 0,
  },
  reducers: {},
  extraReducers: (builder) => {

    builder.addCase(login.fulfilled, (state, action) => {
    if (action?.payload?.data?.success) {
      state.user = action?.payload?.data?.result.user;
      state.token = action?.payload?.data?.result.token;
      state.userLoggedIn = true;

      localStorage.setItem('userData', JSON.stringify(action?.payload?.data?.result.user));
      localStorage.setItem('token', action?.payload?.data?.result.token);
    }
  });


    builder.addCase(changePassword.fulfilled, (state, action) => {
      console.log(action)
      // if (action?.payload?.data?.success) {
      //   state.user = action?.payload?.data?.result.user;
      //   state.userLoggedIn = true;
      //   localStorage.setItem('userData', JSON.stringify(action?.payload?.data?.result.user))
      //   localStorage.setItem('token', action?.payload?.data?.result.token);
      // }
    });

  },
});

export default authSlice.reducer;

export const authSelector = createSelector(
  (state) => state.auth.user,
  (state) => state.auth.token,
  (state) => state.auth.userLoggedIn,
  (state) => state.auth.Activeusers,
  (state) => state.auth.todayNewusers,
  (user, token, userLoggedIn, Activeusers, todayNewusers) => ({
    user,
    token,
    userLoggedIn,
    Activeusers,
    todayNewusers
  })
);